import { render, staticRenderFns } from "./IListIcon.vue?vue&type=template&id=5052891b&scoped=true&"
import script from "./IListIcon.vue?vue&type=script&lang=ts&"
export * from "./IListIcon.vue?vue&type=script&lang=ts&"
import style0 from "./IListIcon.vue?vue&type=style&index=0&id=5052891b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5052891b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBadge,VIcon,VImg,VRow})
